import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsTable.vue?vue&type=template&id=87fa2fa8&"
import script from "./MonthAllowancesPlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports